import React from 'react';
import { Button, Accordion, AccordionSummary, Box } from '@mui/material';
import Icons from '../../components/icons';
import FormRendererV2 from '../../components/FormRenderer/FormRenderer';
import {
  FormSchema,
  FormFieldSchema
} from '../../components/FormRenderer/types'; // Import FormFieldSchema
import { schoolStructureSchema } from './config/schema';
import { useSchoolStructureForm } from './config/useSchoolStructureForm';
import { AccordionHeading, StyledAccordionDetails } from './styled';
import GradeSection from './GradeSection';
import ToastMessage from '../../components/ToastMessage';
import Loader from '../../components/Loader';
import { FixedHeaderBox, FormHeader } from '../SchoolConfig/styled';

const SchoolStructureForm = () => {
  const {
    control,
    handleSubmit,
    formData,
    expandedSection,
    isLoading,
    toastOpen,
    toastSeverity,
    toastMessage,
    handleAccordionChange,
    setValue,
    setToastOpen
  } = useSchoolStructureForm();

  const renderSectionContent = (section: FormFieldSchema) => {
    const isSection = section.type === 'array' && section.name === 'sections';
    const sectionSchema = isSection
      ? (section as any).children || []
      : [section];

    const content =
      section.name === 'sections' ? (
        <GradeSection
          formData={formData}
          setValue={setValue}
          handleAccordionChange={handleAccordionChange}
          control={control}
        />
      ) : (
        <FormRendererV2
          schema={sectionSchema as FormSchema}
          control={control}
        />
      );

    return content;
  };

  if (isLoading) {
    return (
      <Box style={{ padding: '20px' }}>
        <FormHeader>School Structure</FormHeader>
        <Loader show showFullScreen={false} />
      </Box>
    );
  }

  return (
    <>
      <form onSubmit={handleSubmit} style={{ paddingTop: '80px' }}>
        <FixedHeaderBox>
          <FormHeader>School Structure</FormHeader>
          <Button variant='contained' type='submit' color='primary'>
            Save Settings
          </Button>
        </FixedHeaderBox>

        {schoolStructureSchema.map((section: FormFieldSchema) => (
          <Accordion
            key={section.name}
            expanded={expandedSection === section.name}
            onChange={handleAccordionChange(section.name)}
          >
            <AccordionSummary expandIcon={<Icons.CaretDown />}>
              <AccordionHeading>{section.label}</AccordionHeading>
            </AccordionSummary>
            <StyledAccordionDetails>
              {renderSectionContent(section)}
            </StyledAccordionDetails>
          </Accordion>
        ))}
      </form>
      <ToastMessage
        open={toastOpen}
        message={toastMessage}
        severity={toastSeverity}
        onClose={() => setToastOpen(false)}
      />
    </>
  );
};

export default SchoolStructureForm;
